import { useContext } from "react";
import AuthenticatedUserContext from "src/contexts/authentication/AuthenticatedUserContext";

const useCurrentUser = () => {
    const { data } = useContext(AuthenticatedUserContext);
    return data;
};

export default useCurrentUser;
